module.exports = __webpack_public_path__ + "static/media/sr.658b680a.svg";